import { ApiKeyForm } from "@/components/api-key/api-key-form";

export function NewApiKeyPage() {
  return <ApiKeyForm mode="create" />;
}
